{
  "nav": {
    "indicadors": "Indicadores",
    "informes": "Informes",
    "tracabilitat": "Trazabilidad",
    "auditoria": "Auditoría",
    "monitoratge": "Monitorización de envíos",
    "recurrents": "Recurrentes",
    "generador": "Generador de informes",
    "informeActivacio": "Informe de activación",
    "detallTracabilitat": "Trazabilidad"
  },
  "titols": {
    "indicadors": "Cuadro de indicadores",
    "informes": "Informes",
    "tracabilitat": "Trazabilidad de una activación",
    "auditoria": "Registro de auditoría",
    "monitoratge": "Monitorización de envíos",
    "recurrents": "Incidencias recurrentes",
    "generador": "Generador de informes",
    "informeActivacio": "Informe de detalle de activación",
    "detallTracabilitat": "Trazabilidad de una activación"
  },
  "comu": {
    "periode": "Periodo",
    "departament": "Departamento",
    "area": "Área",
    "totsDepartaments": "Todos los departamentos",
    "totesArees": "Todas las áreas",
    "segons": "{{n}} s",
    "minuts": "{{n}} min",
    "hores": "{{n}} h",
    "tendencia": "{{signe}}{{n}} %",
    "exporta": "Exportar",
    "carregant": "Cargando…",
    "senseDades": "No hay datos para el periodo seleccionado",
    "servei": "Servicio",
    "zona": "Zona",
    "senseZona": "Sin zona",
    "veureTot": "Ver todo",
    "torna": "Volver",
    "elimina": "Eliminar",
    "rang": "{{desde}} – {{fins}}",
    "edita": "Editar"
  },
  "periodes": {
    "SETMANA": "Semana",
    "MES": "Mes",
    "TRIMESTRE": "Trimestre"
  },
  "periodicitats": {
    "SETMANAL": "Semanal (lunes 7:00)",
    "MENSUAL": "Mensual (día 1, 7:00)",
    "TRIMESTRAL": "Trimestral (día 1, 7:00)"
  },
  "tipusProgramat": {
    "GLOBAL": "Informe global",
    "COMPARATIVA": "Comparativa por equipos",
    "ACTIVACIONS": "Activaciones",
    "RECURRENTS": "Incidencias recurrentes",
    "INDICADORS": "Indicadores"
  },
  "tipusInforme": {
    "DETALL": {
      "nom": "Detalle de activación",
      "desc": "Destinatarios, canales, marcas de tiempo, confirmaciones, mensajes y acciones"
    },
    "GLOBAL": {
      "nom": "Informe global",
      "desc": "Activaciones, tiempos y cumplimiento del periodo"
    },
    "EQUIP": {
      "nom": "Comparativa por equipo",
      "desc": "Indicadores por departamento y área"
    },
    "AUDITORIA": {
      "nom": "Auditoría y trazabilidad",
      "desc": "Cronología unificada y evidencias de una activación"
    }
  },
  "seccions": {
    "DESTINATARIS": "Destinatarios",
    "CANALS": "Canales",
    "TEMPS": "Marcas de tiempo",
    "MISSATGES": "Mensajes",
    "ACCIONS": "Acciones"
  },
  "events": {
    "ACTIVACIO_CREADA": "Activación creada",
    "DESTINATARI_ENVIAT": "Enviado",
    "DESTINATARI_LLIURAT": "Entregado",
    "DESTINATARI_LLEGIT": "Leído",
    "DESTINATARI_CONFIRMAT": "Confirmado",
    "DESTINATARI_ACCEPTAT": "Aceptado",
    "ENVIAMENT": "Envío",
    "MISSATGE": "Mensaje ({{tipus}})",
    "ACCIO": "Acción ({{tipus}})",
    "ESCALAT": "Escalado",
    "ACTIVACIO_TANCADA": "Activación cerrada"
  },
  "indicadors": {
    "PRIMERA_CONFIRMACIO": "Primera confirmación",
    "ESCALAT_NIVELL": "Escalado al nivel {{n}}",
    "RESOLUCIO": "Resolución"
  },
  "w40": {
    "indicador": "Indicador",
    "valor": "Valor",
    "mitjana": "Media",
    "perPeriode": "Activaciones por periodo",
    "perTipus": "Distribución por tipo",
    "perServei": "Activaciones por servicio",
    "perZona": "Por zona",
    "recurrents": "Incidencias recurrentes",
    "kpi": {
      "activacions": "Activaciones totales",
      "primeraConfirmacio": "1.ª confirmación (media)",
      "escalat": "Escalado (media)",
      "resolucio": "Resolución (media)",
      "confirmacio": "Confirmación",
      "noLliurats": "Avisos no entregados",
      "ambEscalat": "Con escalado",
      "compliment": "Cumplimiento de tiempos"
    },
    "vsAnterior": "{{valor}} vs. periodo anterior",
    "punts": "{{valor}} pp",
    "setmanaN": "Sem. {{n}}",
    "barraTitol": "{{periode}}: {{n}} activaciones",
    "ambPercentatge": "{{n}} ({{pct}})",
    "perDia": "Activaciones por día",
    "perSetmana": "Activaciones por semana",
    "percentTotal": "% del total",
    "llegenda": "{{nom}} · {{pct}}",
    "recurrentsTop": "Incidencias recurrentes (top 3)"
  },
  "w41": {
    "programa": "Programar el envío",
    "nou": "Nuevo informe",
    "comparativa": "Comparativa por departamento y área",
    "equip": "Departamento · Área",
    "tendencia": "Tendencia",
    "activacions": "Activaciones del periodo",
    "informe": "Informe",
    "programats": "Informes programados",
    "senseProgramats": "No hay informes programados",
    "ultimaExecucio": "Última ejecución: {{data}}",
    "actiu": "Activo",
    "inactiu": "Inactivo",
    "vsAnterior": "vs. {{desde}} – {{fins}}",
    "primeraConfirmacio": "1.ª confirmación",
    "resolucio": "Resolución",
    "confirmacio": "% confirmación",
    "peu": "Tendencia calculada sobre el número de activaciones respecto al mismo periodo anterior. Fuente: registro de activaciones."
  },
  "w42": {
    "tipus": "Tipo de informe",
    "filtres": "Filtros",
    "activacio": "Activación",
    "activacioPlaceholder": "ID o código (ACT-2026-0001)",
    "desde": "Desde",
    "fins": "Hasta",
    "format": "Formato",
    "seccions": "Secciones",
    "programacio": "Programación periódica",
    "programar": "Envío periódico",
    "noProgramable": "Este tipo de informe no se puede programar",
    "nom": "Nombre",
    "periodicitat": "Periodicidad",
    "destinataris": "Destinatarios (correos separados por comas)",
    "destinatarisPlaceholder": "nombre@bonarea.com, otro@bonarea.com",
    "desat": "Programación guardada",
    "desaProgramacio": "Guardar la programación",
    "genera": "Generar el informe",
    "errors": {
      "activacio": "Indica una activación",
      "descarrega": "No se ha podido descargar el informe",
      "nom": "El nombre es obligatorio",
      "destinataris": "Indica como mínimo un correo válido",
      "camp": "Campo no válido: {{camp}}",
      "desa": "No se ha podido guardar la programación"
    },
    "titolEdicio": "Editar el informe programado",
    "ambit": "Departamento / área",
    "formatProgramacio": "Formato y programación",
    "recarrega": "Volver a cargar"
  },
  "w43": {
    "descarrega": "Descargar {{format}}",
    "descarregaPdf": "Descargar el PDF",
    "subtitol": "Informe de detalle de activación",
    "generat": "Generado el {{data}}",
    "dades": "Datos de la activación",
    "activador": "Persona activadora",
    "inici": "Inicio del incidente",
    "canals": "Canales",
    "descripcio": "Descripción",
    "proves": "Pruebas realizadas",
    "itcau": "Incidencia ITCAU",
    "confirmats": "Destinatarios y confirmaciones ({{confirmats}}/{{total}})",
    "persona": "Persona",
    "bloc": "Bloque",
    "enviat": "Enviado",
    "lliurat": "Entregado",
    "llegit": "Leído",
    "confirmat": "Confirmado",
    "estat": "Estado",
    "tancament": "Cierre",
    "motiu": "Motivo",
    "tancada": "Cerrada",
    "comentari": "Comentario",
    "peu": "Documento generado por CAI — Centre d'Alertes i Incidències · cai.ba-tech.net",
    "titol": "Informe de detalle · {{codi}}",
    "oberta": "Abierta",
    "durada": "Duración total",
    "cronologia": "Cronología",
    "metadades": "Metadatos",
    "generatEl": "Generado el",
    "generatPer": "Generado por",
    "formatPdf": "PDF",
    "classificacio": "Clasificación",
    "usIntern": "Uso interno"
  },
  "w44": {
    "filtre": "Filtro por categoría",
    "filtres": {
      "TOTS": "Todos",
      "PERMISOS": "Permisos",
      "CONFIGURACIO": "Configuración",
      "USUARIS": "Usuarios",
      "GUARDIES": "Guardias",
      "DOCUMENTACIO": "Documentación",
      "ACTIVACIONS": "Activaciones"
    },
    "resultat": "Resultado",
    "totsResultats": "Todos los resultados",
    "resultats": {
      "OK": "Correcto",
      "ERROR": "Error",
      "DENEGAT": "Denegado"
    },
    "darrers30": "Últimos 30 días",
    "persona": "Persona",
    "data": "Fecha y hora",
    "accio": "Acción",
    "objecte": "Objeto",
    "ip": "Dirección IP",
    "total_one": "{{count}} registro",
    "total_other": "{{count}} registros",
    "anterior": "Anterior",
    "seguent": "Siguiente",
    "pagina": "Página {{n}} de {{total}}",
    "cerca": "Buscar en la auditoría…",
    "sistema": "Sistema"
  },
  "w45": {
    "cerca": "Buscar una activación",
    "cercaPlaceholder": "ID, código (ACT-2026-0001) o título",
    "cercar": "Buscar",
    "resultats": "Resultados",
    "recents": "Activaciones recientes",
    "informe": "Informe",
    "exporta": "Exportar como evidencia",
    "esdeveniments": "Eventos",
    "enviaments": "Envíos",
    "confirmacions": "Confirmaciones",
    "missatges": "Mensajes",
    "escalats": "Escalados",
    "complertsKpi": "Tiempos cumplidos",
    "complerts": "{{n}} / {{total}}",
    "cronologia": "Cronología unificada",
    "temps": "Tiempos comprometidos vs. reales",
    "compromes": "Comprometido",
    "real": "Real",
    "compliment": "Cumplimiento",
    "complert": "Cumplido",
    "noComplert": "No cumplido",
    "pendent": "Pendiente",
    "titol": "Trazabilidad completa · {{codi}}",
    "objectiu": "(objetivo {{temps}})",
    "resum": "Resumen de evidencias",
    "lliuraments": "Entregas",
    "lectures": "Lecturas"
  },
  "w46": {
    "canal": "Canal",
    "totsCanals": "Todos los canales",
    "cua": "Cola pendiente",
    "p50": "Latencia P50",
    "p95": "Latencia P95",
    "ms": "{{n}} ms",
    "enviats": "Enviados (24 h)",
    "darreres24": "Últimas 24 h · ventana móvil",
    "fallits": "Fallidos (24 h)",
    "exit": "Tasa de éxito (24 h)",
    "passarelles": "Pasarelas",
    "estats": {
      "OK": "Operativa",
      "DEGRADAT": "Degradada",
      "KO": "Caída",
      "NO_CONFIGURAT": "No configurada"
    },
    "resum": "{{enviats}} enviados · {{fallits}} fallidos",
    "errors": "Errores recientes",
    "senseErrors": "No hay errores de envío recientes",
    "data": "Fecha y hora",
    "estat": "Estado",
    "codi": "Código",
    "detall": "Detalle",
    "s": "{{n}} s",
    "cuaTitol": "Cola de envíos",
    "pendents_one": "{{count}} pendiente",
    "pendents_other": "{{count}} pendientes",
    "latencia": "Latencia de entrega",
    "global": {
      "OK": "Todas las pasarelas operativas",
      "DEGRADAT": "Degradación parcial",
      "KO": "Pasarela caída",
      "NO_CONFIGURAT": "Hay pasarelas sin configurar"
    }
  },
  "w47": {
    "buit": "No se han detectado incidencias recurrentes",
    "activacions_one": "{{count}} activación",
    "activacions_other": "{{count}} activaciones",
    "grafic": "Activaciones por servicio",
    "taula": "Servicios con más activaciones",
    "patrons": "Patrones detectados",
    "sensePatrons": "No se han detectado patrones relevantes",
    "patro": {
      "MATEIX_SERVEI": {
        "titol": "{{servei}}: {{n}} activaciones recurrentes",
        "recomanacio": "Revisa la causa raíz con el técnico experto y actualiza la documentación del servicio."
      },
      "MATEIXA_ZONA": {
        "titol": "Zona {{zona}}: {{n}} activaciones recurrentes",
        "recomanacio": "Valora medidas preventivas en la zona y avisos preventivos a los usuarios a informar."
      },
      "CONCENTRACIO": {
        "titol": "{{servei}} concentra el {{pct}} % de las recurrencias",
        "recomanacio": "Prioriza este servicio en el plan de mejora y revisa el circuito de escalado."
      }
    },
    "barraTitol": "{{servei}}: {{count}}",
    "etiquetes": {
      "recurrent": "Recurrente",
      "vigilar": "A vigilar"
    },
    "recomanacio": "Recomendación: {{text}}"
  },
  "tipusAccio": {
    "CREADA": "Activación creada",
    "ENVIADA": "Notificación enviada",
    "CONFIRMADA": "Confirmación",
    "ACCEPTADA": "Gestión aceptada",
    "REENVIADA": "Reenvío",
    "ESCALADA": "Escalado",
    "EXPERT_ACTIVAT": "Experto activado",
    "NOTA": "Nota añadida",
    "ITCAU_VINCULAT": "Vinculada a ITCAU",
    "TANCADA": "Cierre",
    "DOCUMENT_CONSULTAT": "Consulta de documentación"
  },
  "tipusMissatge": {
    "TEXT": "texto",
    "MISSATGE": "texto",
    "ACTUALITZACIO": "actualización",
    "RISC": "riesgo",
    "AFECTACIO": "afectación",
    "NOVETAT": "novedad",
    "RECURSOS": "recursos",
    "SISTEMA": "sistema",
    "FINALITZACIO": "finalización"
  },
  "auditoriaAccions": {
    "permis_denegat": "Acceso denegado",
    "rol_permisos_desar": "Cambio de permisos",
    "usuari_rol_assignar": "Asignación de rol",
    "usuari_rol_revocar": "Revocación de rol",
    "usuari_sync_entra": "Sincronización con Entra ID",
    "document_alta": "Subida de documento",
    "document_escaneig": "Análisis de seguridad de documento",
    "document_retirar": "Retirada de documento",
    "document_substituir": "Sustitución de documento",
    "document_edicio": "Actualización de metadatos de documento",
    "activacio_alta": "Alta de activación",
    "activacio_tancar": "Cierre de activación",
    "activacio_escalar": "Escalado de activación",
    "activacio_expert": "Activación de experto",
    "activacio_itcau": "Vinculación ITCAU",
    "activacio_destinataris": "Destinatarios añadidos",
    "servei_usuaris_informar_import": "Importación de usuarios a informar",
    "rotacio_generar": "Generación de rotación",
    "sollicitud_aprovar": "Aprobación de cambio de turno",
    "sollicitud_rebutjar": "Rechazo de cambio de turno",
    "config_modificar": "Cambio de configuración",
    "configuracio_modificar": "Cambio de configuración"
  },
  "auditoriaVerbs": {
    "alta": "Alta",
    "baixa": "Baja",
    "modificar": "Modificación",
    "edicio": "Modificación",
    "eliminar": "Eliminación",
    "desar": "Guardado",
    "assignar": "Asignación",
    "revocar": "Revocación",
    "aprovar": "Aprobación",
    "rebutjar": "Rechazo",
    "cancellar": "Cancelación",
    "generar": "Generación",
    "import": "Importación",
    "retirar": "Retirada",
    "substituir": "Sustitución",
    "tancar": "Cierre",
    "escalar": "Escalado",
    "denegat": "Acceso denegado"
  },
  "auditoriaEntitats": {
    "configuracio": "Configuración",
    "rol": "Rol",
    "usuari": "Usuario",
    "activacio": "Activación",
    "app_versio": "Versión de la app",
    "calendari": "Calendario",
    "circuit_escalat": "Circuito de escalado",
    "document": "Documento",
    "document_versio": "Versión de documento",
    "politica_fitxers": "Política de ficheros",
    "grup": "Grupo",
    "informe_programat": "Informe programado",
    "missatge_admin": "Mensaje de administración",
    "area": "Área",
    "departament": "Departamento",
    "servei": "Servicio",
    "zona": "Zona",
    "plantilla": "Plantilla",
    "rotacio": "Rotación",
    "sollicitud_canvi_torn": "Solicitud de cambio de turno",
    "tipus_avis": "Tipo de aviso",
    "torn": "Turno"
  }
}
